"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function tbx(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M11.775 20.55C6.9285 20.55 3 16.6215 3 11.775C3 6.9285 6.9285 3 11.775 3C16.6215 3 20.55 6.9285 20.55 11.775C20.55 16.6215 16.6215 20.55 11.775 20.55ZM13.9425 14.775L11.775 11.775L9.6075 14.775L7.845 11.775L9.81 8.415H13.74L15.705 11.775L13.9425 14.775ZM14.5875 6.975H8.9625L6.1575 11.775L8.97 16.575H14.5875L17.3925 11.775L14.5875 6.975Z", fill: color }),
        React.createElement("path", { d: "M12 20.775C7.15351 20.775 3.22501 16.8465 3.22501 12C3.22501 7.15354 7.15351 3.22504 12 3.22504C16.8465 3.22504 20.775 7.15354 20.775 12C20.775 16.8465 16.8465 20.775 12 20.775ZM14.1675 15L12 12L9.83251 15L8.07001 12L10.035 8.64004H13.965L15.93 12L14.1675 15ZM14.8125 7.20004H9.18751L6.38251 12L9.19501 16.8H14.8125L17.6175 12L14.8125 7.20004Z", fill: color }));
}
exports["default"] = tbx;
//# sourceMappingURL=tbx.js.map